export default __webpack_public_path__ + "static/media/ico_mng-services.74f8637d.png";